import { Grid, LinearProgress, Stack } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-premium";
import dayjs from "dayjs";
import { t } from "i18next";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DynamicCatalogBuilder } from "../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder";
import { MuiStack } from "../../../components";
import PagingHeader from "../../../components/atoms/pagingHeader";
import CatalougeHeaderComponent from "../../../components/molecules/catalougeHeaderComponent";
import { DesktopTabComponent } from "../../../components/molecules/desktopTabComponent";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { resetState } from "../../../redux/crudSlice";
import { useAppSelector } from "../../../store/hooks";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { isLoadingState } from "../../../utils/utils";
import { CustomDownloadIcon, CustomPencilIcon, CustomPrintIcon, CustomShareIcon } from "../../jobCardDetails/assets/customIcons";
import NoDocumnetFound from "../../stockTransfer/components/noDocumentFound";
import { JournalDetailPagingAPICall } from "../services/apiCalls";
import { APIKeys, JournalVoucherKeys, JournalVoucherViewTypeOptions } from "../services/entity";
var JournalVoucher = function () {
    var _getLocalStorageItem, _getLocalStorageItem2, _crud$JournalVoucherK, _crud$JournalVoucherK2;
    var dispatch = useDispatch();
    var crud = useAppSelector(function (state) { return state.crud; });
    var _a = useState('list'), activeView = _a[0], setActiveView = _a[1];
    var _b = useState(false), isFilterOpen = _b[0], setFilterOpen = _b[1];
    var navigate = useNavigate();
    var menuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_SUB_MENU);
    var filterValue = useAppSelector(function (state) { return state.crud; }).filterValue;
    var _c = useState(JournalVoucherViewTypeOptions[0].id), viewTypeValue = _c[0], setViewTypeValue = _c[1];
    var onToggleViewChange = function (view) {
        setActiveView(view);
    };
    var customActionColumns = [{
            field: 'Code',
            headerName: 'JV number',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.Code ? "".concat(row === null || row === void 0 ? void 0 : row.Code) : '-'; },
            minWidth: 200
        }, {
            field: 'CreatedBy',
            headerName: 'Created by',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.CreatedBy ? "".concat(row === null || row === void 0 ? void 0 : row.CreatedBy) : '-'; },
            minWidth: 200
        }, {
            field: 'Status',
            headerName: 'Status',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.Status ? "".concat(row === null || row === void 0 ? void 0 : row.Status) : '-'; },
            minWidth: 200
        }, {
            field: 'TotalCreaditAmount',
            headerName: 'Total credit (₹)',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.TotalCreaditAmount ? "".concat(row === null || row === void 0 ? void 0 : row.TotalCreaditAmount) : '-'; },
            minWidth: 150
        }, {
            field: 'TotalDebitAmount',
            headerName: 'Total debit (₹)',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.TotalDebitAmount ? "".concat(row === null || row === void 0 ? void 0 : row.TotalDebitAmount) : '-'; },
            minWidth: 150
        }, {
            type: 'date',
            field: 'Date',
            headerName: 'JV date',
            valueFormatter: function (value) { return dayjs(value).format('DD MMM, YYYY'); },
            minWidth: 150
        }, {
            type: 'date',
            field: 'CreatedOn',
            headerName: 'Created date',
            valueFormatter: function (value) { return dayjs(value).format('DD MMM, YYYY'); },
            minWidth: 150
        }, {
            type: 'actions',
            field: 'actions',
            headerName: 'Actions',
            getActions: function (params) {
                var _menuFeatures$Feature;
                return menuFeatures === null || menuFeatures === void 0 || (_menuFeatures$Feature = menuFeatures.Features) === null || _menuFeatures$Feature === void 0 ? void 0 : _menuFeatures$Feature.map(function (data) { /*#__PURE__*/ return React.createElement(GridActionsCellItem, {
                    label: data.DisplayName,
                    icon: data.Name === "Print" ? /*#__PURE__*/ React.createElement(CustomPrintIcon, {
                        fontSize: "small"
                    }) : data.Name === "DownloadPDF" ? /*#__PURE__*/ React.createElement(CustomDownloadIcon, {
                        fontSize: "small"
                    }) : (data === null || data === void 0 ? void 0 : data.Name) === 'Share' ? /*#__PURE__*/ React.createElement(CustomShareIcon, {
                        fontSize: "small"
                    }) : /*#__PURE__*/ React.createElement(CustomPencilIcon, {
                        fontSize: "small"
                    }),
                    showInMenu: true,
                    onClick: function () { return handleRowClick(params.row.id, data.Name); }
                }); });
            }
        }];
    var handleRowClick = function (id, Name) {
        if (Name === "Edit") {
            navigate("/journalVoucher/createJournalVoucher/".concat(id, "?mode=edit"));
        }
    };
    var request = {
        Branches: filterValue !== null && filterValue !== void 0 && filterValue.BranchId ? [filterValue === null || filterValue === void 0 ? void 0 : filterValue.BranchId] : [(_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH)) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId],
        ServiceAdviserId: filterValue === null || filterValue === void 0 ? void 0 : filterValue.ServiceAdvisorId,
        IdentityId: viewTypeValue === 1 ? (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.IdentityId : undefined,
        TechnicianId: filterValue === null || filterValue === void 0 ? void 0 : filterValue.TechnicianId,
        FromDate: filterValue !== null && filterValue !== void 0 && filterValue.StartDocDate ? filterValue === null || filterValue === void 0 ? void 0 : filterValue.StartDocDate : "",
        ToDate: filterValue !== null && filterValue !== void 0 && filterValue.EndDocDate ? filterValue === null || filterValue === void 0 ? void 0 : filterValue.EndDocDate : filterValue !== null && filterValue !== void 0 && filterValue.StartDocDate ? filterValue === null || filterValue === void 0 ? void 0 : filterValue.StartDocDate : ""
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isLoadingState([JournalVoucherKeys.JournalDetailPaging]) && /*#__PURE__*/ React.createElement(LinearProgress, {
        sx: {
            mt: 0.6
        }
    }), /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        paddingLeft: 1,
        borderBottom: '1px solid #DEE4EB'
    }, /*#__PURE__*/ React.createElement(DesktopTabComponent, {
        sx: {
            width: "100%",
            paddingX: 1
        },
        tabVariant: "standard",
        showTabIndicator: true,
        bgColorApply: true
    })), /*#__PURE__*/ React.createElement(PagingHeader, {
        data: (_crud$JournalVoucherK = crud[JournalVoucherKeys.JournalDetailPaging]) === null || _crud$JournalVoucherK === void 0 ? void 0 : _crud$JournalVoucherK.data,
        headerTitle: t("Journal Voucher"),
        onButtonClick: function () {
            dispatch(resetState(APIKeys));
            navigate('./createJournalVoucher?mode=add');
        },
        activeView: activeView,
        onToggleView: onToggleViewChange
    }), /*#__PURE__*/ React.createElement(CatalougeHeaderComponent, {
        pagingAPI: JournalDetailPagingAPICall,
        options: JournalVoucherViewTypeOptions,
        onFilterClick: function () { return setFilterOpen(true); },
        pagingRequest: request,
        setViewTypeValue: setViewTypeValue
    }), ((_crud$JournalVoucherK2 = crud[JournalVoucherKeys.JournalDetailPaging]) === null || _crud$JournalVoucherK2 === void 0 || (_crud$JournalVoucherK2 = _crud$JournalVoucherK2.data) === null || _crud$JournalVoucherK2 === void 0 ? void 0 : _crud$JournalVoucherK2.length) > 0 ? /*#__PURE__*/ React.createElement(Grid, {
        p: 2
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        pagingAPIKey: JournalVoucherKeys.JournalDetailPaging,
        columns: customActionColumns,
        getPagingData: JournalDetailPagingAPICall,
        pagingAPIRequest: request
        // dataGridProps={{
        //     onRowClick: (event) => handleRowClick(event?.row?.id),
        //     disableColumnMenu: false,
        // }}
    })) : /*#__PURE__*/ React.createElement(Stack, null, /*#__PURE__*/ React.createElement(NoDocumnetFound, {
        title: t("Start managing your Journal vouchers!"),
        paragraph: t("Create, customize, and send professional Journal vouchers to your group."),
        buttonUpload: t('Upload'),
        buttonNew: t('New'),
        onButtonNewClick: function () {
            navigate('./createJournalVoucher?mode=add');
            dispatch(resetState(APIKeys));
        }
    })));
};
export default JournalVoucher;
